import { Context } from '@nuxt/types';

export default function (ctx: Context) {
  try {
    const isTransactionsPage = ctx.route.path === '/transactions';
    const isHomepage = ctx.route.path === '/';
    const isEmpty = ctx.store.getters['VirtualOrderModule/allFetchedTransactions'].length === 0;

    if (isTransactionsPage || isHomepage || isEmpty) {
      ctx.store.commit('VirtualOrderModule/setTransactionsCurrentPage', 1);
      return ctx.store.dispatch('VirtualOrderModule/fetchTransactions');
    }
  } catch (e) {
    console.error(e);
  }
}
